import PropTypes from 'prop-types';

import BaseButton from '../BaseButton';

const noop = () => {};

const FabButton = ({
  onClick = noop,
  color = 'primary',
  disabled = false,
  dataTest = null,
  className = null,
  renderContent = null,
  renderIcon = null,
  size = 'medium'
}) => (
  <BaseButton
    className={className}
    onClick={onClick}
    color={color}
    size={size}
    disabled={disabled}
    dataTest={dataTest}
    roundedCorners
    dropShadow
    renderContent={renderContent}
    renderIcon={renderIcon}
  />
);

FabButton.propTypes = {
  renderContent: PropTypes.func,
  renderIcon: PropTypes.func,
  className: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'tertiary-light'
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  dataTest: PropTypes.string
};

export default FabButton;
